import { BaseClient } from './BaseClient'

export class HowToPayApi extends BaseClient {
  getQuestions = this.createRequest({
    url: '/api/faqs?filters[type][$eq]=how-to-pay',
    method: 'get',
  })
  getHowToPaySeo = this.createRequest({
    url: '/api/how-to-pay-page-home',
    method: 'get',
  })
}
